import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins'

const ContractApiV2 = {
  /**
   * Get list of `Contract`
   * @return {object} Collection of `Contract`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params   = QueryParamsUtil.format(tableState, additionalFilters)
    const path     = `${API_PATH}/contracts`
    const response = axios.get(path, { params })
    return response
  }
}

export default ContractApiV2
